import { render } from "./exposurereport.vue?vue&type=template&id=15833887&scoped=true"
import script from "./exposurereport.js?vue&type=script&lang=js"
export * from "./exposurereport.js?vue&type=script&lang=js"

import "./exposurereport.vue?vue&type=style&index=0&id=15833887&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15833887"]])

export default __exports__